import { Component, Inject, Input, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { IBanner, EnumBannerClass, App } from '@libs/types';
import { APP_CONFIG } from '@libs/configs';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'control-bar',
  templateUrl: 'control-bar.component.html',
  styleUrls: ['./control-bar.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class ControlBarComponent {
  mobile = true;
  bannerClass = EnumBannerClass;
  enableTopNav: boolean;

  @Input() title: string;
  @Input() returnTo: string | null = null;
  @Input() style: 'normal' | 'short' | 'long' = 'normal';
  @Input() hasActions = true;
  @Input() noSidebar = false;
  /**
   * Adds borderBottom on tablet and bigger view widths
   */
  @Input() borderBottom = false;
  @Input() banner: IBanner;
  @Input() navigateByUrl: boolean = false;

  constructor(
    private breakpointObserver: BreakpointObserver,
    private router: Router,
    @Inject(APP_CONFIG) private appConfig: any,
  ) {
    this.enableTopNav = this.appConfig.enableTopNav;

    breakpointObserver.observe([Breakpoints.Handset]).subscribe((result) => {
      this.mobile = !!result.matches;
    });
  }

  handleReturnTo(): void {
    if (!this.returnTo) {
      return;
    }

    if (this.navigateByUrl) {
      this.router.navigateByUrl(this.returnTo);
    } else {
      this.router.navigate([this.returnTo]);
    }
  }
}
